import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { get, noop } from 'lodash';

import { fillPaginationPages } from 'lib/array';
import thematize from 'lib/thematize';
import messages from './messages';
import styles from './PaginationTailless.scss';

interface Props {
  last: AH$Page | Record<string, unknown>;
  nextLabel: React.ReactElement;
  onClick: (page: number) => void;
  prevLabel: React.ReactElement;
  selectedPage: number;
  visiblePages: number;
}

class PaginationTailless extends React.Component<Props> {
  static defaultProps = {
    last: {},
    visiblePages: 5,
    selectedPage: 1,
    prevLabel: <FormattedMessage {...messages.prev} />,
    nextLabel: <FormattedMessage {...messages.next} />,
  };

  theme = thematize(styles);

  handlePrevClick = (): void => {
    this.props.onClick(this.props.selectedPage - 1);
  };

  handleNextClick = (): void => {
    this.props.onClick(this.props.selectedPage + 1);
  };

  handlePageClick = (page: number): void => {
    this.props.onClick(page);
  };

  render(): React.ReactElement {
    const { last, prevLabel, nextLabel, visiblePages, selectedPage } = this.props;
    const lastPage = parseInt((get(last, 'page') as string) || '1', 10);
    const activePage = selectedPage > lastPage ? lastPage : selectedPage;
    const pages = fillPaginationPages(visiblePages, lastPage, activePage);
    const prevDisabled = activePage === 1;
    const nextDisabled = activePage === lastPage;

    return (
      <div className={this.theme('container')}>
        <div
          className={this.theme('prev', { disabled: prevDisabled })}
          onClick={prevDisabled ? noop : this.handlePrevClick}
        >
          {prevLabel}
        </div>

        {visiblePages < lastPage && activePage >= visiblePages && (
          <div className={this.theme('break')}>...</div>
        )}

        <div className={this.theme('pages-container')}>
          {pages.map((i) => {
            const active = activePage === i;

            return (
              <div
                key={i}
                className={this.theme('page', { active })}
                onClick={(): void => (active ? noop() : this.handlePageClick(i))}
              >
                {i}
              </div>
            );
          })}
        </div>

        {visiblePages < lastPage && activePage < lastPage - 1 && (
          <div className={this.theme('break')}>...</div>
        )}

        <div
          className={this.theme('next', { disabled: nextDisabled })}
          onClick={nextDisabled ? noop : this.handleNextClick}
        >
          {nextLabel}
        </div>
      </div>
    );
  }
}

export default PaginationTailless;
